module.exports = __webpack_public_path__ + "img/8.c8a6d9ed.png";